import { useState, useEffect, useRef } from 'react';
import cornerImage from '../../styles/Image (1).jpg';
import { MenuContainer, MenuItem, RightMenuItems } from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import ModalRedefinirSenha from '../ModalRedefinirSenha';
import NotificationCenter from '../NotificationCenter';
import { API_CONFIG } from '../../config/api';

const Menu = () => {
    const [isProfileOpen, setIsProfileOpen] = useState(false); 
    const menuRef = useRef<HTMLDivElement>(null);
    const [nome] = useState(localStorage.getItem('nome') || '');
    const [sobrenome] = useState(localStorage.getItem('sobrenome') || '');
    
    const iniciais = `${nome.charAt(0)}${sobrenome.charAt(0)}`.toUpperCase();
    
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsProfileOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleProfileClick = () => {
        setIsProfileOpen(!isProfileOpen);
    };

    const handleLogout = async () => {
        try {
          await fetch(`${API_CONFIG.AUTH_URL}/logout`, {
            method: 'POST',
            credentials: 'include'
          });
        } catch (err) {
          console.warn('Erro ao fazer logout:', err);
        }
        
        localStorage.clear();
        window.location.href = '/login';
      };
      
    const [showModalRedefinirSenha, setShowModalRedefinirSenha] = useState(false);

    return (
        <>
            <MenuContainer ref={menuRef}>
                <RightMenuItems>
                    <NotificationCenter />
                    <MenuItem onClick={() => window.open('https://angaasset.atlassian.net/servicedesk/customer/portals')}>
                        <FontAwesomeIcon icon={faHeadset} />
                    </MenuItem>
                    <MenuItem onClick={handleProfileClick} className="profile-button">
                        <img src={cornerImage} alt="perfil" className="profile-avatar" />
                        {isProfileOpen && (
                            <div className="profile-dropdown">
                                <div className="profile-item" onClick={() => setShowModalRedefinirSenha(true)}>
                                    <span>Alterar senha</span>
                                </div>
                                <div className="profile-item" onClick={() => handleLogout()}>
                                    <span>Sair</span>
                                </div>
                            </div>
                        )}
                    </MenuItem>
                </RightMenuItems>
            </MenuContainer>
            <ModalRedefinirSenha show={showModalRedefinirSenha} onHide={() => setShowModalRedefinirSenha(false)} />
        </>
    );
};

export default Menu; 